export const URL = {
  oyo_url: "https://oyo-rooms-backend.onrender.com",
  login: "https://oyo-rooms-backend.onrender.com/login",
  signup: "https://oyo-rooms-backend.onrender.com/signup",
  hotelPost: "https://oyo-rooms-backend.onrender.com/addhotel",
  hotel: "https://oyo-rooms-backend.onrender.com/gethotels",
  users: "https://oyo-rooms-backend.onrender.com/getuserdata",
};
